module.exports = __webpack_public_path__ + "images/73b3f61.png";